import branding from "./branding";

const ooru = {
  id: "ooru",
  branding,
};

export default ooru;
